/* Presentation only. The existing builder owns selections, prices and cart writes. */
(() => {
  if (window.EvolvedSetupMobile) return;
  window.EvolvedSetupMobile = true;
  const media = matchMedia('(max-width: 999px)');
  const states = new Map();
  const sv = document.documentElement.lang.toLowerCase().startsWith('sv');
  const copy = sv ? {title:'Paketrabatt', more:'Visa niv\u00e5er', extra:'extra', up:'Upp till', unlocked:'uppl\u00e5st'} : {title:'Bundle savings', more:'See tiers', extra:'extra', up:'Up to', unlocked:'unlocked'};
  const update = state => {
    const current = state.shell.querySelector('.evs-incentive-current')?.textContent.match(/\d+(?:[.,]\d+)?%/)?.[0];
    const maximum = state.tiers.lastElementChild?.querySelector('strong')?.textContent.trim();
    const text = current ? `${current} ${copy.extra} ${copy.unlocked}` : maximum ? `${copy.up} ${maximum} ${copy.extra}` : copy.more;
    if (state.value.textContent !== text) state.value.textContent = text;
  };
  const mount = state => {
    if (!state.tiers.isConnected) return;
    if (media.matches) {
      if (!state.details.isConnected) {
        state.tiers.before(state.details);
        state.details.append(state.tiers);
      }
      state.shell.dataset.evMobileSimplified = 'true';
      update(state);
    } else {
      delete state.shell.dataset.evMobileSimplified;
      if (state.details.isConnected) {
        state.details.before(state.tiers);
        state.details.remove();
      }
    }
  };
  const register = shell => {
    if (states.has(shell)) return;
    const tiers = shell.querySelector('.evs-progress .evs-tiers');
    const incentive = shell.querySelector('.evs-incentive');
    if (!tiers || !incentive) return;
    const details = document.createElement('details');
    details.className = 'evs-mobile-savings';
    const summary = document.createElement('summary');
    const title = document.createElement('span');
    title.textContent = copy.title;
    const value = document.createElement('span');
    value.className = 'evs-mobile-savings__value';
    const icon = document.createElement('span');
    icon.className = 'evs-mobile-savings__icon';
    icon.setAttribute('aria-hidden','true');
    icon.textContent = '+';
    summary.append(title,value,icon);
    details.append(summary);
    const note = document.createElement('p');
    note.className = 'evs-mobile-savings__note';
    note.textContent = sv ? 'Extra rabatt på reapriser. En produkt per kategori.' : 'Extra savings on sale prices. One product per category.';
    if (note.textContent) details.append(note);
    const state = {shell,tiers,details,value};
    state.observer = new MutationObserver(() => update(state));
    state.observer.observe(tiers,{childList:true,subtree:true,characterData:true});
    state.observer.observe(incentive,{childList:true,subtree:true,characterData:true});
    states.set(shell,state);
    mount(state);
  };
  let frame = 0;
  const scan = () => {
    frame = 0;
    for (const [shell,state] of states) {
      if (!shell.isConnected || !shell.contains(state.tiers)) {
        state.observer.disconnect();
        states.delete(shell);
      }
    }
    document.querySelectorAll('.evs-shell').forEach(register);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(scan); };
  const init = () => {
    scan();
    const root = document.getElementById('main') || document.body;
    new MutationObserver(records => {
      if (records.some(record => {
        const shell = record.target instanceof Element ? record.target.closest('.evs-shell') : null;
        return !shell || !states.has(shell) || !shell.querySelector('.evs-mobile-savings') && media.matches;
      })) schedule();
    }).observe(root,{childList:true,subtree:true});
  };
  media.addEventListener('change',() => states.forEach(mount));
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

